module.exports = __webpack_public_path__ + "static/media/loginImage.4b14f511.png";